export interface LinkRow {
  name: string;
  url: string;
  col2: string;
  col3: string;
}

export interface LinkTable {
  title: string;
  headers: [string, string, string];
  rows: LinkRow[];
}

export const linkTables: LinkTable[] = [
  {
    title: '数学関係のWebサイト',
    headers: ['サイト名', 'コメント1', 'コメント2'],
    rows: [
      {
        name: 'MATHEMATICS',
        url: 'https://math.stackexchange.com/',
        col2: '数学一般',
        col3: '数学専門の質問サイト。',
      },
      {
        name: 'Math Overflow',
        url: 'https://mathoverflow.net/',
        col2: '数学一般',
        col3: '数学専門の質問サイト。',
      },
      {
        name: 'arXiv.org',
        url: 'https://arxiv.org/',
        col2: '数学一般',
        col3: 'プレプリントがダウンロード出来る。',
      },
      {
        name: 'ねくMath',
        url: 'http://neqmath.com/',
        col2: '数学一般',
        col3: 'きーねく氏のウェブサイトです。',
      },
      {
        name: "Atsushi Yamaguchi's Homepage",
        url: 'http://www.las.osakafu-u.ac.jp/~yamaguti/',
        col2: '',
        col3: 'ノートが凄い。',
      },
      {
        name: 'nLab',
        url: 'https://ncatlab.org/',
        col2: '圏論',
        col3: '大抵のことは載っている。',
      },
      {
        name: 'はじまりはKan拡張',
        url: 'https://infinitytopos.wordpress.com/',
        col2: '圏論',
        col3: '',
      },
      {
        name: '壱大整域',
        url: 'http://alg-d.com/',
        col2: '圏論/AC/整数論',
        col3: '殆ど本だと思う。',
      },
      {
        name: 'Avendia19',
        url: 'http://ziphil.com/',
        col2: '圏論',
        col3: '日記とその他とより数学の記事に飛べる。',
      },
      { name: 'iso.2022.jp', url: 'http://iso.2022.jp/', col2: '基礎論', col3: '' },
      {
        name: '決定不能問題ギャラリー',
        url: 'http://iso.2022.jp/math/undecidable-problems/',
        col2: '決定不能問題',
        col3: '上記のウェブサイトの一部。',
      },
      {
        name: 'なげやりアカデミア',
        url: 'http://tenasaku.com/academia/',
        col2: '集合論',
        col3: 'Kunenの解答などもあり。',
      },
      {
        name: 'konn-san.com 建設予定地',
        url: 'https://konn-san.com/',
        col2: '集合論',
        col3: '',
      },
      { name: 'GAPのブログ', url: 'http://eurekagap.seesaa.net/', col2: '集合論', col3: '' },
      {
        name: 'とりマセ Σ^0_2',
        url: 'http://recursion-theory.blogspot.com/2015/06/blog-post.html',
        col2: 'ヴォート予想',
        col3: '',
      },
      {
        name: 'Metamath Proof Explorer',
        url: 'http://us.metamath.org/mpegif/mmset.html',
        col2: '基礎論',
        col3: 'Hilbert流で困ったらココ。',
      },
      {
        name: '酒井克郎のホームページ',
        url: 'https://sites.google.com/site/ksakaiidtopology/home',
        col2: '位相空間論',
        col3: '',
      },
      {
        name: 'トポロジーいろいろ',
        url: 'https://yamyamtopo.wordpress.com/',
        col2: '位相空間論',
        col3: '',
      },
      {
        name: "Dan Ma's Topology Blog",
        url: 'https://dantopology.wordpress.com/',
        col2: '位相空間論',
        col3: '',
      },
      {
        name: '龍孫江の数学日誌',
        url: 'http://blog.livedoor.jp/ron1827-algebras/',
        col2: '可換環論',
        col3: '可換環論Botのブログです。',
      },
      {
        name: 'Pantodon Web Site',
        url: 'http://pantodon.shinshu-u.ac.jp/',
        col2: '代トポ',
        col3: '',
      },
      {
        name: 'Algebraic Topology',
        url: 'http://pantodon.shinshu-u.ac.jp/topology/literature/',
        col2: '代トポ',
        col3: '上記のサイトの一部。',
      },
      {
        name: 'ALGEBRAIC TOPOLOGY JOURNALS',
        url: 'http://www.clas.wayne.edu/disaksen/Algebraic-topology-journals',
        col2: '代トポ',
        col3: '代トポのジャーナルまとめ。',
      },
      {
        name: 'The Stacks project',
        url: 'https://stacks.math.columbia.edu/',
        col2: '代数幾何',
        col3: '辞書です。',
      },
      { name: 'Traum', url: 'https://mathcalhiro.tumblr.com/', col2: '代数幾何', col3: '' },
      { name: 'ワヘイヘイ概型', url: 'http://waheyhey.com/', col2: '代数幾何', col3: '' },
      {
        name: 'Encyclopedia of P-adic Nnumbers',
        url: 'http://padic.wicurio.com/',
        col2: '整数論',
        col3: 'p進に特化したサイト。',
      },
      {
        name: 'Kolchin Seminar in Differential Algebra',
        url: 'https://ksda.ccny.cuny.edu/',
        col2: '微分代数?',
        col3: 'Kolchin Seminarの公式サイト。',
      },
      {
        name: 'Kolchin Seminar in Differential Algebra',
        url: 'https://www.youtube.com/channel/UCLX8E_MY-Frg1NV9aEF_6Ng/playlists',
        col2: '微分代数?',
        col3: 'ようつべのチャンネル。講義が見られる。',
      },
      {
        name: '超局所的物置',
        url: 'https://sites.google.com/site/microlocaldustbox/',
        col2: '代数解析',
        col3: '',
      },
      {
        name: '戸田正人の講義ノート',
        url: 'https://sites.google.com/site/hutianzhengrennojiangyinoto/',
        col2: '数学一般',
        col3: '講義ノートが纏まっている。',
      },
      {
        name: '数学：物理を学び楽しむために',
        url: 'http://www.gakushuin.ac.jp/~881791/mathbook/',
        col2: '数学一般',
        col3: '物理に必要な数学が学べる文献。',
      },
      {
        name: 'ぷりんの雑記帳',
        url: 'http://puddingderivative.blog.fc2.com/',
        col2: '数学一般',
        col3: '',
      },
      {
        name: "Asuka's Notes",
        url: 'https://asuka-math.amebaownd.com/',
        col2: '数学一般',
        col3: 'Noteが非常に読みやすい。',
      },
      { name: 'でぃぐのページ', url: 'http://fujidig.github.io/', col2: '数学一般', col3: '' },
      {
        name: 'http://searial.web.fc2.com',
        url: 'http://searial.web.fc2.com/aerile_re/index.html',
        col2: '数学一般',
        col3: 'ラングレー型問題を解いた人。',
      },
      {
        name: '数理科学【数学】',
        url: 'http://home.p07.itscom.net/strmdrf/sci_math.htm',
        col2: '数学一般',
        col3: '',
      },
      {
        name: 'うぶつん',
        url: 'https://ubutun.blogspot.com/',
        col2: '数学一般',
        col3: '行間がない。',
      },
    ],
  },
  {
    title: '数学関係のブログ（はてぶ）',
    headers: ['サイト名', 'コメント1', 'コメント2'],
    rows: [
      {
        name: 'INTEGERS',
        url: 'http://integers.hatenablog.com/',
        col2: '整数論',
        col3: 'せきゅーん氏のブログ。',
      },
      {
        name: 'tsujimotterのノートブック',
        url: 'http://tsujimotter.hatenablog.com/',
        col2: '整数論',
        col3: 'tsujimotter氏のブログ。',
      },
      {
        name: 'あのKTOKの数学blog',
        url: 'http://ano-ktok.hatenablog.com/',
        col2: '解析学',
        col3: 'あのKTOK氏のブログ。',
      },
      {
        name: 'おぼえがき',
        url: 'http://hackberryfield.hatenablog.com/',
        col2: '関数解析など',
        col3: '鈴木土下座ェ門氏のブログ。pdfが豊富。',
      },
      {
        name: '冬の数学日記',
        url: 'http://wagomu.hatenablog.com/',
        col2: '代数',
        col3: '冬氏のブログ。',
      },
      {
        name: '腸内環境異常',
        url: 'http://shannon-mth.hatenablog.com/',
        col2: 'アーベル群論/圏論',
        col3: 'シャノン氏のブログ。',
      },
      {
        name: '電波通信',
        url: 'http://concious4410.hatenablog.com/',
        col2: '位相空間論',
        col3: '意識氏のブログ。pdfが豊富。',
      },
      {
        name: "CommonNoun's diary",
        url: 'http://commonnoun.hatenadiary.jp/',
        col2: '位相空間論',
        col3: 'クレイモア氏のブログ。',
      },
      {
        name: '記号の世界より',
        url: 'http://tetobourbaki.hatenablog.com/',
        col2: '数学一般',
        col3: 'Loveブルバキ氏のブログ。',
      },
      {
        name: '檜山正幸のキマイラ飼育記',
        url: 'http://d.hatena.ne.jp/m-hiyama/',
        col2: '圏論',
        col3: '檜山正幸氏のブログ。',
      },
    ],
  },
  {
    title: '数学のテキスト',
    headers: ['書名', '著者', '備考'],
    rows: [
      {
        name: '3次元多様体入門',
        url: 'http://tunnel-knot.sakura.ne.jp/3-manifolds.html',
        col2: '森元勘治',
        col3: '絶版。',
      },
      {
        name: 'A Course in Universal Algebra',
        url: 'http://www.math.uwaterloo.ca/~snburris/htdocs/ualg.html',
        col2: 'S. N. Burris, H. P. Sankappanavar',
        col3: '普遍代数の入門書。',
      },
      {
        name: 'Category Theory in Context',
        url: 'http://www.math.jhu.edu/~eriehl/context.pdf',
        col2: 'E. Riehl',
        col3: '圏論の入門書。',
      },
      {
        name: 'Category Theory',
        url: 'http://angg.twu.net/MINICATS/awodey__category_theory.pdf',
        col2: 'S. Awodey',
        col3: '圏論の入門書。',
      },
      {
        name: 'Sheaves in Geometry and Logic',
        url: 'http://atondwal.org/Sheaves_in_Geometry_and_Logic__MacLane_Moerdijk.pdf',
        col2: 'S. M. Lane, I. Moerdijk',
        col3: '所謂SGL。トポスを学べる。',
      },
    ],
  },
  {
    title: '数学関係の団体のWebサイト',
    headers: ['団体名', 'コメント1', 'コメント2'],
    rows: [
      {
        name: '都内数学科学生集合',
        url: 'https://tosuu.web.fc2.com/',
        col2: '関東',
        col3: '通称都数。私も所属しています。',
      },
      {
        name: '数学カフェ',
        url: 'http://mathcafe-japan.hatenadiary.com/',
        col2: '関東',
        col3: '誰もが参加できる数学のセミナーを開催している団体です。',
      },
      {
        name: '数物セミナー',
        url: 'http://physmathseminar.web.fc2.com/',
        col2: '全国',
        col3: '合宿と談話会とが主な活動のようです。',
      },
      {
        name: '関西数学徒のつどい',
        url: 'http://kansaimath.tenasaku.com/',
        col2: '関西',
        col3: '通称つどい。',
      },
      {
        name: 'The Dark Side of Forcing',
        url: 'http://forcing.nagoya/',
        col2: '名古屋',
        col3: '数学同人サークル。過去の同人誌(ハイレベル)が読める。',
      },
      {
        name: '暗黒通信団',
        url: 'http://ankokudan.org/d/',
        col2: '全国?',
        col3: '本を出版している。',
      },
      { name: '無限次☆計画', url: 'http://mugenji.web.fc2.com/', col2: '関東?', col3: '' },
    ],
  },
  {
    title: 'TeX関係のWebサイト',
    headers: ['サイト名', 'コメント1', 'コメント2'],
    rows: [
      {
        name: 'Detexify',
        url: 'http://detexify.kirelabs.org/classify.html',
        col2: 'TeX',
        col3: '記号に困ったらココ',
      },
      {
        name: 'TeX',
        url: 'https://tex.stackexchange.com/',
        col2: 'TeX',
        col3: 'TeX専門の質問サイト。',
      },
      {
        name: '数学の常識・非常識―由緒正しいTeX入力法',
        url: 'http://mathsoc.jp/publication/tushin/0401/oda4-1.pdf',
        col2: 'TeX',
        col3: '小田忠雄先生のpdf。直リンク。',
      },
    ],
  },
];
